// Remembers that the splash Loader has already played, so it only shows once per visit.
const SEEN_KEY = 'khamsa-loader-seen';

export function hasLoaderPlayed() {
    try {
        return sessionStorage.getItem(SEEN_KEY) === '1';
    } catch {
        return false;
    }
}

export function markLoaderPlayed() {
    try {
        sessionStorage.setItem(SEEN_KEY, '1');
    } catch {
        // ignore: storage unavailable, the splash simply shows again next time
    }
}
